<script>
import { Bar, mixins } from 'vue-chartjs'
import Chart from 'chart.js'

export default {
  extends: Bar,
  mixins: [mixins.reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    chartText: {
      type: Boolean,
      default: true
    }
  },

  mounted () {
    this.addPlugin({
      beforeRender: (chart) => {
        if (chart.config.options.showAllTooltips) {
          chart.pluginTooltips = []
          chart.config.data.datasets.forEach((dataset, i) => {
            chart.getDatasetMeta(i).data.forEach((sector, j) => {
              chart.pluginTooltips.push(new Chart.Tooltip({
                _chart: chart.chart,
                _chartInstance: chart,
                _data: chart.data,
                _options: chart.options.tooltips,
                _active: [sector]
              }, chart))
            })
          })
          chart.options.tooltips.enabled = false
        }
      },
      afterDraw: (chart, easing) => {
        if (this.chartText) {
          const ctx = chart.ctx
          chart.data.datasets.forEach((dataset, i) => {
            const meta = chart.getDatasetMeta(i)
            if (!meta.hidden) {
              meta.data.forEach((element, index) => {
                ctx.fillStyle = 'rgb(55, 71, 79, 1)'

                const fontSize = 12
                const fontStyle = 'normal'
                const fontFamily = 'Helvetica Neue'
                ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily)

                // const dataString = chart.data.labels[index] + ' : ' + dataset.data[index].toString()
                const dataString = dataset.data[index].toString()

                ctx.textAlign = 'center'
                ctx.textBaseline = 'middle'

                const padding = 5
                const position = element.tooltipPosition()
                if (dataString !== '0') {
                  ctx.fillText(dataString, position.x, position.y - (fontSize / 2) - padding)
                } else {
                  return
                }
              })
            }
          })
        }
      }
    })

    console.log(Bar)
    console.log(mixins)

    this.renderChart(this.chartData, this.options)
  }
}
</script>




// WEBPACK FOOTER //
// BarChartB.vue?7c05cd10